module.exports = __webpack_public_path__ + "static/media/compliance.20628db3.png";